export default {
  tableTabs: [
    {
      title: "همه‌ رمزارز‌ها",
      id: 1
    },
    {
      title: "علاقه‌مندی‌ها",
      id: 2
    }
  ],
  searchInputPlaceholder: "جستجو براساس نام ارز و یا نام اختصاری...",
  categoriesMenu: ["محبوب ترین", "ارزان ترین", "گران ترین"],
  headers: [
    {
      text: "",
      align: "center",
      sortable: false,
      value: "fave",
      width: 70
    },
    {
      text: "#",
      align: "center",
      sortable: true,
      value: "rank",
      width: 70
    },
    {
      text: "نام ارز",
      align: "start",
      sortable: true,
      value: "name_locale"
    },
    {
      text: "قیمت (دلار)",
      value: "price",
      align: "right",
      sortable: true
    },
    {
      text: "تغییرات 24h",
      value: "daily_change_percent",
      align: "right",
      sortable: true
    },
    {
      text: "قیمت فروش ما (ریال)",
      value: "price_buy",
      align: "right",
      sortable: true
    },
    {
      text: "قیمت خرید ما (ریال)",
      value: "price_sell",
      align: "right",
      sortable: true
    },
    {
      text: "حجم بازار (دلار)",
      value: "market_cap",
      align: "right",
      sortable: true
    }
    /*{
          text: "نمودار قیمت",
          value: "diagramPrice",
          align: "center",
          sortable: false
        },*/
    /*{ text: "عملیات", value: "actions", align: "center", sortable: false }*/
  ],
  noResults: "نتیجه‌ای یافت نشد.",
  noResultsForFave: " لیست علاقه‌مندی‌های شما خالی است"
};
